import { Injectable } from "@angular/core";
import { ApiCountryResult, ListImage, DataImageDetails, isLocalImg } from "@models/interfaces/index";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ConfigService } from "@shared/config/services/config.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable()
export class ImagesService {
    private randomNumber: number;

    public constructor(
        private http: HttpClient,
        private readonly config: ConfigService,
    ) {
        this.randomNumber = Math.floor(Math.random() * 3);
    }

    public getImagesCountries(imgContext: string): Observable<DataImageDetails[]> {
        const url: string = `${this.config.get("apiImages")}`;

        const apiToken: string = `${this.config.get("apiToken")}`;
        const httpOptions: object = {
            headers: new HttpHeaders().set("Authorization", apiToken),
        };

        return this.http.get(`${url}/?search=${imgContext}&include=images`, httpOptions).pipe(
            map((data: ApiCountryResult) => {
                let result: DataImageDetails[] = [];

                if (null != data && null != data.included) {
                    result = data.included.filter((included: DataImageDetails) => included.type === "image");
                }

                return result;
            }),
        );
    }

    public checkImgSource(data: ListImage): string {
        if (!!data) {
            if (isLocalImg(data)) {
                if (data.name.split(".").pop() === "pdf") {
                    return "";
                }
                return `${data.userImage}`;
            }
            const pattern =
                /\/(upload|preview|bankdetails|avatar)\/(([+-]?(?=.d|d)(?:d+)?(?:.?d*))(?:[eE]([+-]?d+))?([a-zA-Z]+([+-]?(?=.d|d)(?:d+)?(?:.?d*))(?:[eE]([+-]?d+))?)+)*/;
            if (data.match(pattern)) {
                if (data.split(".").pop() == "pdf") {
                    return "";
                }
                return `${this.config.get("apiFolderPublic")}${data}`;
            }

            const imgRegex = /(\/assets\/img\/[a-zA-Z]+)|(dist\/images\/[a-zA-Z]+)/;
            if (imgRegex.test(data)) {
                if (
                    data === "/assets/img/mv-default-cover-contribute.png" ||
                    data === "dist/images/bg-pv-3.jpg" ||
                    data === "/assets/img/mv--default--cover.png"
                ) {
                    return "/assets/img/default-cover-contribute.jpg";
                }
                return `${this.config.get("apiFolderPublic")}${data}`;
            }

            if (data) {
                return `https://b${this.randomNumber}.marcovasco.fr/sites/default/files/styles/fbcover/public/${data}`;
            }
        }
        return "";
    }

    public isExtentionAllowed(fileName: string): boolean {
        return ["jpg", "jpeg", "png", "gif"].includes(String(fileName.split(".").pop()?.toLocaleLowerCase()));
    }
}
